import React from 'react';

const ProcessSkeletonLoader: React.FC = () => {
    return (
        <div className="home-process-skeleton">
            <div className="skeleton-icon"></div>
            <div className="skeleton-content">
                <div className="skeleton-title"></div>
                <div className="skeleton-meta">
                    <div className="skeleton-tag"></div>
                    <div className="skeleton-text"></div>
                    <div className="skeleton-date"></div>
                </div>
            </div>
            <div className="skeleton-arrow"></div>
        </div>
    );
};

export default ProcessSkeletonLoader;
